import { render, staticRenderFns } from "./ConstructionApp.vue?vue&type=template&id=0e4c175c"
import script from "./ConstructionApp.vue?vue&type=script&lang=js"
export * from "./ConstructionApp.vue?vue&type=script&lang=js"
import style0 from "./ConstructionApp.vue?vue&type=style&index=0&id=0e4c175c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports